import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import type React from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { useSessions } from "~/hooks/vendors/useSessions";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";
import { CompanySettingList } from "./CompanySettingList";

export const Page: React.FC = () => {
	const { data: session } = useSessions().index();

	if (session === null) {
		return null;
	}

	return (
		<VendorLayoutV2>
			<VendorSettingLayout>
				<div className={SettingStyles.SpBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "設定一覧" },
							{ label: "提携中の管理会社一覧" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader title="提携中の管理会社一覧" />
					<PanelBody>
						<CompanySettingList session={session} />
					</PanelBody>
				</Panel>
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
};
